import { ChevronsUpDown } from "lucide-react"

import { Button } from "@/components/ui/button.tsx"
import { Calendar } from "@/components/ui/calendar.tsx"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover.tsx"

import type { DateRange } from "react-day-picker"

export default function DateFilter({
  label,
  value,
  setValue,
  variant,
}: {
  label: string
  value?: DateRange
  setValue: (v: DateRange | undefined) => void
  variant?:
    | "default"
    | "link"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | null
    | undefined
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant={variant ? variant : "ghost"} className="w-full flex justify-between">
          {label} <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto overflow-hidden p-0" align="start">
        <Calendar
          mode="range"
          captionLayout="dropdown"
          selected={value}
          onSelect={setValue}
          required={false}
          timeZone="UTC"
          defaultMonth={value && value.from ? value.from : new Date()}
        />
      </PopoverContent>
    </Popover>
  )
}
